import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/configureStore";
import { AlertRequest } from "../../app/types";
import { getAlert } from "../app/selectors";
import { addAlert } from "../app/uiSlice";

const useAlert = (alertRequest: AlertRequest, handler: () => void) => {
  const dispatch = useAppDispatch();
  const [uuid, setUuid] = useState<string>();

  const alert = useAppSelector(getAlert(uuid));

  const showAlert = useCallback(() => {
    const { payload } = dispatch(addAlert(alertRequest));
    setUuid(payload.uuid);
  }, [alertRequest, dispatch]);

  useEffect(() => {
    if (uuid && alert === undefined) {
      setUuid(undefined);
      handler();
    }
  }, [alert, handler, uuid]);

  return showAlert;
};

export default useAlert;
